// autogenerated from 'yarn strings'
const d = {"page":"Pagina {page} di {pages}"};
export default d;